<template lang="pug">
    span(style="display:inline-block")
        el-button(
            :disabled="$apollo.loading"
            :loading="loading"
            @click="toggle"
            :icon="enabled ? 'fe fe-zap-off fe-just-off' : 'fe fe-zap fe-just-off'"
            :type="!enabled ? 'success' : 'danger'"
        ) {{ enabled ? `Disable ${buttonLabel}` : `Enable ${buttonLabel}` }}
</template>
<script>
import gql from "graphql-tag";
import _ from "lodash";
export default {
    props: {
        isOrganisation: Boolean,
        buttonLabel: String,
    },

    data() {
        return {
            loading: false,
            enabled: null,
        };
    },

    apollo: {
        enabled: {
            query: gql`
                query Settings($type: SettingsTypeEnum!) {
                    Settings(type: $type) {
                        id
                        auto_sync_classes
                    }
                }
            `,
            variables() {
                return {
                    type: this.isOrganisation ? "organisation" : "school"
                }
            },
            update(r) {
                return r.Settings.auto_sync_classes;
            }
        }
    },

    methods: {
        async toggle() {
            this.setEnabled(!this.enabled);
        },

        async setEnabled(enabled) {
            this.loading = true;
            await this.$apollo
                .mutate({
                    mutation: gql`
                        mutation SaveSettings($object: SettingsInput!, $type: SettingsTypeEnum!) {
                            SaveSettings(object: $object, type: $type) {
                                auto_sync_classes
                            }
                        }
                    `,
                    variables: {
                        object: {
                            auto_sync_classes: enabled
                        },
                        type: this.isOrganisation ? "organisation" : "school"
                    },
                    update: () => {
                        this.enabled = enabled;
                    }
                })
                .then(r => {
                    this.loading = false;
                })
                .catch(e => {
                    this.loading = false;
                    this.$message.error("Failed action");
                });
            this.$emit("auto-sync-classes-change")
        }
    }
};
</script>
